import { get } from '@js/common/api'

import { errorLogger } from '@f-fertighaus/utils/errorLogger'

export const EMAIL_VALIDATION_REGEXP = /^(?!.*(?:test\.com|test\.de|tester\.com|tester\.de|anonymized\.com))(?:(?:(?:(?:[^<>()[\]\\.,;:\s@"]+(?:\.[^<>()[\]\\.,;:\s@"]+)*)|(?:".+"))@(?:(?:(?:[0-9]{1,3}\.){3}[0-9]{1,3})|(?:(?:[a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))|)$/i
export const POSTAL_CODE_REGEXP = /^(?!12345|98765)\d{4,5}$/
export const STREET_VALIDATION_REGEX = /^(?!^vagina|schwanz|hurensohn|sexstr|musterstr|asdf|qwert|abcd|werbung|test|furz|arschloch|pimmel|abc|bla|blah|penis|spam|fick)(?=.*\d)[0-9A-zäöüßòàáâçéèêëîïôûùÿñæœ/ ,.-]*[^\d\s][\w\-/\s]*$/i
export const CITY_VALIDATION_REGEX = /^(?!.*(?:asdf|qwert|abcd))(?!^(?:vagina|schwanz|hurensohn|werbung|test|furz|arschloch|pimmel|abc|bla|blah|penis|spam|fick)$)[0-9A-zäöüßòàáâçéèêëîïôûùÿñæœ/ ,.-]*[^\d\s][\w\-/\s]*$/i
const PASSWORD_VALIDATION_REGEXP = /^[\S ]{8,200}$/
export const NAME_VALIDATION_REGEXP = /^(?!.*\d)(?!.*(?:asdf|qwert|abcd))(?!^(?:vagina|schwanz|hurensohn|werbung|test|furz|arschloch|pimmel|abc|bla|blah|penis|spam|fick)$)/i
export const LAST_NAME_VALIDATION_REGEXP = /^(?!.*\d)(?!.*(?:asdf|qwert|abcd))(?!^(?:vagina|schwanz|hurensohn|werbung|test|furz|arschloch|pimmel|abc|bla|blah|penis|spam|fick)$)/i
export const INAPPRIORIATE_WORD_REGEXP = /\b(asdf|qwert|abcd|vagina|schwanz|hurensohn|werbung|test|furz|arschloch|pimmel|abc|bla|blah|penis|spam|fick)\b/
export const NUMBER_REGEX = /^(0|[1-9]\d*)(\.\d+)?$/

export type validationTypes =
  | 'not-empty'
  | 'street'
  | 'postal-code'
  | 'city'
  | 'password'
  | 'e-mail'
  | 'first-name'
  | 'last-name'
  | 'number-api-check'
  | 'at-least-two-characters-long'
  | 'not-matches-another-input'
  | 'is-number'
  | 'is-greater-than-zero'

export const VALIDATION_FUNCTIONS: Record<
  validationTypes,
  ((currentValue: string) => boolean) | null
> = {
  'not-empty': currentValue => currentValue.trim() !== '',
  street: currentValue => STREET_VALIDATION_REGEX.test(currentValue),
  city: currentValue => CITY_VALIDATION_REGEX.test(currentValue),
  'postal-code': currentValue => POSTAL_CODE_REGEXP.test(currentValue),
  password: currentValue => PASSWORD_VALIDATION_REGEXP.test(currentValue),
  'e-mail': currentValue => EMAIL_VALIDATION_REGEXP.test(currentValue),
  'first-name': currentValue => NAME_VALIDATION_REGEXP.test(currentValue),
  'last-name': currentValue => LAST_NAME_VALIDATION_REGEXP.test(currentValue),
  'is-number': currentValue => NUMBER_REGEX.test(currentValue),
  'is-greater-than-zero': currentValue => parseFloat(currentValue) > 0,
  'number-api-check': null,
  'not-matches-another-input': null,
  'at-least-two-characters-long': currentValue =>
    Boolean(currentValue && currentValue.length >= 2)
}

interface PhoneValidationResponse {
  phone_formatted: string
  phone_origin: string
  phone_type: string
  phone_valid: boolean
}

export const validatePhoneByAPICall = (countryCode: string, number?: string) =>
  new Promise<boolean>(resolve => {
    get(`phone-validation/${countryCode}/${number}`)
      .then((res: PhoneValidationResponse) => {
        if (res.phone_valid) {
          resolve(true)
        } else {
          resolve(false)
        }
      })
      .catch(errorLogger)
  })

export const validationMessage = {
  firstName: {
    required: 'Bitte Vornamen angeben.',
    tooShort: 'Vollständiger Vorname benötigt.',
    notMatchesAnotherInput: 'Ungültige Eingabe.',
    inappropriate: 'Ungültige Eingabe.'
  },
  lastName: {
    required: 'Bitte Nachnamen angeben.',
    tooShort: 'Vollständiger Nachname benötigt.',
    inappropriate: 'Ungültige Eingabe.'
  },
  email: {
    required: 'Bitte E-Mail-Adresse angeben.',
    valid: 'Bitte eine gültige E-Mail-Adresse angeben.'
  },
  phone: {
    required: 'Bitte Telefonnummer angeben.',
    phone: 'Bitte eine gültige Telefonnummer angeben.',
    valid:
      'Bitte geben Sie Ihre richtige Handynummer an. Einige Anbieter senden die gewünschten Informationen nur an Interessenten mit vollständig korrekten Kontaktdaten. Danke!'
  },
  gender: {
    required: 'Bitte wählen Sie eine Antwort aus.'
  },
  street: {
    required: 'Bitte Straße und Hausnummer angeben.',
    requiredWithoutNumber: 'Bitte Straße angeben.',
    inappropriate: 'Ungültige Eingabe.'
  },
  streetNumber: {
    required: 'Bitte Hausnummer angeben.'
  },
  postalCode: {
    required: 'Bitte PLZ angeben.',
    postalCode: 'Bitte PLZ angeben.',
    countryNoMatch: 'Ungültige Postleitzahl für dieses Land.'
  },
  city: {
    required: 'Bitte Stadt angeben.',
    inappropriate: 'Ungültige Eingabe.'
  },
  birthdate: {
    required: 'Bitte tragen Sie ein Geburtsdatum ein.'
  }
}

export const POSTAL_CODE_LENGTH_BY_COUNTRY: Record<string, number> = {
  DE: 5,
  AT: 4
}
